module.exports = __webpack_public_path__ + "a3d400b20fd22b552992cb5835e365c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/michael.png
// module id = 1509
// module chunks = 0